import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7f7cf366&scoped=true&lang=pug"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=7f7cf366&prod&lang=stylus&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=7f7cf366&prod&lang=stylus&scoped=true"
import style2 from "./detail.vue?vue&type=style&index=2&id=7f7cf366&prod&lang=stylus&scoped=true"
import style3 from "./detail.vue?vue&type=style&index=3&id=7f7cf366&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7cf366",
  null
  
)

export default component.exports